import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../_state';
import LockIcon from '@mui/icons-material/Lock';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 16;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

export default function List(props) {
  const auth = useRecoilValue(authAtom);

  const { name, kind, category, file, columns, onRowClick, onCreateClick, hideTitle } = props;
  const [srchData, setSrchData] = useState({});
  const [rows, setRows] = useState([]);
  const [noticeRows, setNoticeRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);
  const [progItem, setProgItem] = useState([]);
  const [progSelected, setProgSelected] = useState([]);
  const [secretPwDialog, setSecretPwDialog] = useState({ open: false, postState: null, postKind: null, postId: null });
  const [secretPw, setSecretPw] = useState('');

  const navigate = useNavigate();

  const handleChangeSrch = (e) => {
    let id = e.target.id.replace('Srch', '');
    setSrchData({ ...srchData, [id]: e.target.value });
  };

  const navigateToDetail = (data) => {
    const detailState = { name, kind, id: data.id, categoryItem: progItem };
    if (onRowClick) {
      onRowClick(detailState);
    } else {
      navigate('/detail', { state: detailState });
    }
  };

  const handleRowClick = (data) => (evt) => {
    if (data.is_secret) {
      // 관리자: 바로 이동
      if (auth?.role === 'ROLE_ADMIN') {
        navigateToDetail(data);
        return;
      }
      // 로그인 회원 본인(루트 작성자 또는 이 게시글 작성자): 바로 이동
      if (auth?.userid && (auth.userid === data.top_created_id || auth.userid === data.created_id)) {
        navigateToDetail(data);
        return;
      }
      // 루트가 비회원인 스레드: 비밀번호 확인
      if (!data.top_created_id) {
        setSecretPw('');
        setSecretPwDialog({ open: true, postState: data, postKind: kind, postId: data.id });
        return;
      }
      // 그 외(타인 비밀글): 차단
      return;
    }
    navigateToDetail(data);
  };

  const handleSecretPwConfirm = async () => {
    try {
      await axios.post(`/api/board/verify-password/${secretPwDialog.postKind}/${secretPwDialog.postId}`, { guestPassword: secretPw });
      const data = secretPwDialog.postState;
      setSecretPwDialog({ open: false, postState: null, postKind: null, postId: null });
      navigateToDetail(data);
    } catch (error) {
      alert(error.response?.data?.message || '비밀번호가 일치하지 않습니다.');
    }
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const getDataList = async (e) => {
    const { subject, createdId } = srchData;
    let params = {
      offset,
      page,
      limit: offset,
      subject,
      createdId,
      kind,
      category: progSelected,
      isNotice: false
    };

    const response = await axios.get(`/api/board/${kind}`, { params });
    if (response.data) {
      const result = response.data;
      setPageCnt(Math.ceil(result.count / offset));
      setRows(result.rows);
      if (e?.target) {
        setPage(1);
      }
    }
  };

  const getNoticeList = async (e) => {
    let params = {
      kind,
      category: progSelected,
      isNotice: true
    };

    const response = await axios.get(`/api/board/${kind}`, { params });
    if (response.data) {
      const result = response.data;
      setNoticeRows(result);
    }
  };

  const getProgList = async (e) => {
    const response = await axios.get(`/api/pgm`, { params: { viewYn: true, kind: 'public' } });
    response.data.unshift({ engNm: 'common', korNm: '공통' });
    await setProgItem(response.data);
    await setProgSelected(response.data.map((t) => t.engNm));
  };

  const handleChangeMultiSelect = (event) => {
    const {
      target: { value, name }
    } = event;

    if (value[value.length - 1] === 'all') {
      const items = progItem.map((t) => t.engNm);
      setProgSelected(progSelected.length === progItem.length ? [] : items);
      return;
    }
    setProgSelected(value);
  };

  const createBoard = async (e) => {
    const registerState = { name, kind, categoryItem: progItem, file };
    if (onCreateClick) {
      onCreateClick(registerState);
    } else {
      navigate('/register', { state: registerState });
    }
  };

  useEffect(async () => {
    if (!!category) {
      getProgList();
    }
  }, []);

  useEffect(async () => {
    await getNoticeList();
    await getDataList(page);
  }, [page, kind]);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      {!hideTitle && (
        <Typography component="h2" variant="h6" color="primary" gutterBottom>
          {name}
        </Typography>
      )}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Stack direction="row" spacing={2}>
            <TextField id="subjectSrch" variant="outlined" size="small" label="제목" value={srchData?.subject || ''} onChange={handleChangeSrch} />
            <TextField id="createdIdSrch" variant="outlined" size="small" label="등록자" value={srchData?.createdId || ''} onChange={handleChangeSrch} />
            <Button variant="contained" onClick={getDataList}>
              검색
            </Button>
          </Stack>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {noticeRows.map((row, rowIdx) => (
                  <TableRow hover key={row.id} onClick={handleRowClick(row)}>
                    {columns.map((col, colIdx) => (
                      <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.subjectAlign || col.align}>
                        {col.id === 'id' ? '공지' : row[col.id]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id} onClick={handleRowClick(row)}>
                    {columns.map((col, colIdx) => {
                      return (
                        <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.subjectAlign || col.align}>
                          {col.id === 'subject' && row['parent_id'] != row['id'] ? <SubdirectoryArrowRightIcon fontSize={'small'} sx={{ ml: row['level'] * 2 }} /> : ''}
                          {col.id === 'created_id'
                            ? (row['author_name'] || row['created_id'] || '-')
                            : row[col.id]}
                          {col.id === 'subject' && row['is_secret'] ? <LockIcon fontSize={'small'} /> : ''}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
            </Container>
            <Stack direction="row" spacing={2} justifyContent="flex-end">
              <Button variant="contained" onClick={createBoard}>
                글쓰기
              </Button>
            </Stack>
          </TableContainer>
        </Grid>
      </Grid>

      {/* 비회원 비밀글 비밀번호 확인 다이얼로그 */}
      <Dialog open={secretPwDialog.open} onClose={() => setSecretPwDialog({ open: false, postState: null, postKind: null, postId: null })}>
        <DialogTitle>비밀번호 확인</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            label="게시글 비밀번호"
            type="password"
            size="small"
            fullWidth
            value={secretPw}
            onChange={(e) => setSecretPw(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSecretPwConfirm()}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSecretPwDialog({ open: false, postState: null, postKind: null, postId: null })}>취소</Button>
          <Button onClick={handleSecretPwConfirm} variant="contained">확인</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
}
